export const allowClassesAndLinks = {
  allowedAttributes: {
    '*': ['class', 'style'],
    a: ['href', 'name', 'target', 'noopener', 'noreferrer'],
  },
};
